export default {
  de: {
    titles: {
      start_page: 'Startseite',
      login: 'Einloggen',
      register: 'Registrieren',
      profile: 'Profil',
      logout: 'Ausloggen',
      impressum: 'Impressum',
      forgot_password: 'Passwort vergessen',
      reset: 'Passwort zurücksetzen',
      email_verification: 'E-Mail-Verifizierung',
      update_password: 'Ändere das Passwort',
      update_profile: 'Profil aktualisieren',
      calendar: 'Kalender',
      notifications: 'Benachrichtigungen',
      calendar_entry: 'Kalendereintrag',
      report_a_problem: 'Ein Problem melden',
      datenschutz: 'Datenschutz',
      new_car: 'New car',
      new_service_time: 'New service time',
      new_expense: 'New expense',
      leaves: 'Urlaubsanträge',
      create_leave: 'Antrag erstellen',
      export_multi_expenses: 'Download multiple expenses reports',
      downloads: 'Downloads',
      remark_preview: 'Bemerkung',
      notice: 'Hinweis',
    },
    fields: {
      name: 'Name',
      category: 'Kategorie',
      remark: 'Bemerkung',
      select_option: 'Option auswählen',
      first_name: 'Vorname',
      last_name: 'Nachname',
      email: 'Email',
      password: 'Passwort',
      password_confirmation: 'Passwort Bestätigung',
      repeat_password: 'Passwort wiederholen',
      current_password: 'Derzeitiges Passwort',
      new_password: 'Neues Kennwort',
      new_password_repeat: 'Bestätige neues Passwort',
      gender: 'Geschlecht',
      dob: 'Geburtsdatum',
      licenses: 'Lizenzen',
      street: 'Straße',
      postal_code: 'Postleitzahl',
      town: 'Stadt',
      country: 'Land',
      nationality: 'Staatsangehörigkeit',
      bank_name: 'Bank Name',
      iban: 'IBAN',
      bic: 'BIC',
      vip: 'VIP',
      location: 'Ort',
      start_date_and_time: 'Startdatum und -zeit',
      end_date_and_time: 'Enddatum und -zeit',
      type: 'Typ',
      sex: {
        1: 'Herr',
        2: 'Frau',
      },
      sum_service_times_select: 'Wählen Sie aus, um Servicezeiten zu summieren',
    },
    table_labels: {
      sum_service_times_select: 'Wählen Sie aus, um Servicezeiten zu summieren',
      attachment: 'Anhang',
    },
    placeholders: {
      name: 'Name eingeben',
      first_name: 'Vorname eingeben',
      last_name: 'Nachname eingeben',
      email: 'Email eingeben',
      password: 'Passwort eingeben',
      password_confirmation: 'Passwort Bestätigung eingeben',
      current_password: 'Aktuelles Passwort eingeben',
      new_password_repeat: 'Passwortbestätigung eingeben',
      description: 'Beschreibung eingeben',
      comment: 'Kommentar eingeben',
      date: 'Datum auswählen',
      licenses: 'Lizenzen eingeben',
      street: 'Straße eingeben',
      postal_code: 'Postleitzahl eingeben',
      town: 'Stadt eingeben',
      country: 'Land eingeben',
      nationality: 'Staatsangehörigkeit eingeben',
      bank_name: 'Bank Name eingeben',
      iban: 'IBAN eingeben',
      bic: 'BIC eingeben',
      date_interval_start: 'Start des Datumsintervalls',
      date_interval_end: 'Datumsintervallende',
      license_plate: 'Bitte geben Sie das Kennzeichen im Format „DO KK 123" ein.',
      car_type: 'Auto typ',
      owner: 'Inhaber',
      total_service_time: 'Gesamte Servicezeit',
      search: 'Tippen um zu suchen',
      locations_multiselect: 'Nach Standort filtern',
    },
    actions: {
      continue: 'Weiter',
      forgot_password: 'Passwort vergessen?',
      register_now: 'Jetzt neu registrieren',
      send_forgot_password: 'Neues Passwort anfordern',
      submit: 'Speichern',
      ok: 'OK',
      stop: 'Abbrechen',
      clear: 'Löschen',
      export_expenses: 'Ausgabenersatzbeleg herunterladen',
      duplicate: 'Duplizieren',
      sum: 'Summieren',
      previous: 'Vorheriger Monat',
      today: 'Heute',
      next: 'Nächster Monat',
      open_report: 'Report öffnen',
      open: 'Öffnen',
      mark_read: 'Als gelesen markieren',
      mark_all_read: 'Alle als gelesen markieren',
      dismiss: 'Ausblenden',
    },
    messages: {
      no_calendar_entries: 'Keine Kalendereinträge in diesem Monat.',
      scheduled_service_time: 'Geplante Servicezeit',
      reported_service_time: 'Erfasste Servicezeit',
      no_notifications: 'Keine Benachrichtigungen',
      forgot_password_sent: 'Der Wiederherstellungslink wurde an Ihre E-Mail-Adresse gesendet',
      password_changed: 'Das Passwort wurde zurückgesetzt. Sie können sich jetzt einloggen.',
      empty_list: 'Die Liste ist leer.',
      select_category_first: 'Bitte wählen Sie zuerst eine Kategorie aus.',
      multiselect_enter: 'Geben Sie mindestens 3 Buchstaben ein.',
      please_send: 'Bitte senden Sie alle Originalbelege klar beschriftet mit der Expense-ID (rot / z.B. #149) an:',
      own_interest: 'In eurem eigenen Interesse bitten wir euch, eine Kopie der Belege zu machen bevor ihr sie verschickt.',
      before_address:
        'Nach Abschluss des Reports die Auslagenabrechnung herunterladen, und per Email an folgende Adresse senden: expenses@kks-hahn.de',
      complete_warning:
        'Bitte füllen Sie alle roten Felder aus, um einen Report im Status „Draft“ (als Entwurf) zu speichern. Um einen Report als „Completed“ zu speichern, müssen zusätzlich auch die grünen Felder gefüllt sein.',
    },
    errors: {
      terms: 'Sie müssen die Datenschutzrichtlinien akzeptieren, um die Registrierung fortzusetzen.',
    },
    infos: {
      licenses: 'Beschreiben Sie Ihren Führerschein und andere Lizenzen für die Beförderung von Passagieren usw.',
      bic: 'Nur bei Konten außerhalb Deutschlands notwendig',
      meeting_point: 'Ort an dem der Einsatz beginnt',
      meeting_date: 'Start-Zeitpunkt des Einsatzes',
      meeting_notes: 'Kurze Schliderung des Auftrages, z.B.: 8:00 Uhr FH-Pickup, Fahrt ins Hotel, etc., sowie kurze Erklärung der diversen Kosten',
      vip_description: 'Es muss das Feld „VIP" ODER das Feld "VIP description" ausgefüllt sein, um den Bericht zu speichern.',
      status: 'Draft = Bearbeitungsmodus / ' + 'Completed = Bearbeitung abgeschlossen',
      license_plate: 'Kennzeichen',
      car_type: 'Fahrzeugtyp',
      car_owner: 'Fahrzeughalter',
      car_use: 'Verwendetes Fahrzeug',
      date: 'Auftragsdatum',
      zub: 'Bitte hier ein Foto der ersten Seite des Fahrzeugscheins hochladen.',
      takeover_from: 'Person oder Firma, die dir das Fahrzeug übergeben hat.',
      return_to: 'Person oder Firma, an die das Fahrzeug übergeben wurde.',
      takeover_date: 'Zeitpunkt der Fahrzeugübernahme',
      return_date: 'Zeitpunkt der Fahrzeugrückgabe',
      km_status_takeover: 'Kilometerstand Fahrzeugübernahme',
      km_status_return: 'Kilometerstand Fahrzeugrückgabe. Bitte bei Langzeitmieten und Transportern eintragen.',
      approach_start: 'Beginn der Anfahrt',
      approach_end: 'Ende der Anfahrt',
      service_start: 'Beginn des Fahrdienst',
      service_end: 'Ende des Fahrdienst',
      return_start: 'Beginn der Abfahrt',
      return_end: 'Ende der Abfahrt',
      note: 'Kurze Schliderung des Auftrages, z.B.: 8:00 Uhr FH-Pickup, Fahrt ins Hotel, etc., sowie kurze Erklärung der diversen Kosten',
      cost_type: 'Auswahl der Kostenart. Bitte beachtet den Steuersatz und ob die Kosten in Deutschland oder im Ausland angefallen sind.',
      expense_date: 'Datum an dem die Kosten angefallen sind',
      amount: 'Betrag in Euro',
      amount_description: 'Kurze Erklärung der Kosten',
      showing_results: 'Zeige {start} bis {end} von {total} Ergebnissen an',
      job_location: 'Ort des Auftrags',
    },
    search: {
      message: 'Die Suche funktioniert nach {entity}.',
      entities: {
        description: 'der Beschreibung',
        article_name: 'dem Bezeichnung',
        firm_name: 'dem Firmenname',
        name: 'dem Name',
      },
    },
    alerts: {
      duplicate_entity: 'Möchten Sie diesen {entity} duplizieren?',
    },
    copyright: '© 2019 KKS',
    name: 'KKS',
    tos: 'Datenschutzrichtlinien',
    term: 'Ich akzeptiere die {0} von Potpourri',
  },
};
